import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { ContenuPosePushVideo } from '@components/contenu-pose-push-video/models';
import { ButtonComponent } from '@shared/components/button';
import { CardTitleTextHtmlComponent } from '@shared/components/card-title-text-html';
import { TitleComponent } from '@shared/components/title';
import { YoutubePlayerComponent } from '@shared/components/youtube-player';
import { YoutubeIdExtractorPipe } from '@shared/components/youtube-player/pipes';

@Component({
  selector: 'app-contenu-pose-push-video',
  imports: [
    CardTitleTextHtmlComponent,
    ButtonComponent,
    TitleComponent,
    YoutubePlayerComponent,
    YoutubeIdExtractorPipe,
  ],
  templateUrl: './contenu-pose-push-video.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContenuPosePushVideoComponent extends AbstractDynamicComponent<ContenuPosePushVideo> {}
